import { ADD_SELECTED_INTEREST, ADD_SELECTED_SKILL,REMOVE_SELECTED_INTEREST,REMOVE_SELECTED_SKILL, SET_FORM_DATA,ADD_LIKED_JOB,REMOVE_LIKED_JOB  } from '../actions/profileSetupActions';
import { LOGOUT } from '../actions/authActions'; 

const initialState = {
  // postalCode: '',
  selectedInterests: [],
  selectedSkills: [],
  formData: {},
  likedJobs: [],
};

const profileSetupReducer = (state = initialState, action) => {
  switch (action.type) {
    // case SET_POSTAL_CODE:
    //   return {
    //     ...state,
    //     postalCode: action.payload,
    //   };
      
    case ADD_SELECTED_INTEREST:
      return {
        ...state,
        selectedInterests: [...state.selectedInterests, action.payload],
      };
    
    case ADD_SELECTED_SKILL:
      return {
        ...state,
        selectedSkills: [...state.selectedSkills, action.payload],
      };
      case REMOVE_SELECTED_INTEREST:
      return {
        ...state,
        selectedInterests: state.selectedInterests.filter(interest => interest !== action.payload),
      };

    case REMOVE_SELECTED_SKILL:
      return {
        ...state,
        selectedSkills: state.selectedSkills.filter(skill => skill !== action.payload),
      };
      
      case SET_FORM_DATA:
        return { ...state, formData: { ...state.formData, ...action.payload } };

        case ADD_LIKED_JOB:
      if (state.likedJobs.find(job => job.id === action.payload.id)) {
        return state; 
      }
      return {
        ...state,
        likedJobs: [...state.likedJobs, action.payload],
      };

    case REMOVE_LIKED_JOB:
      return {
        ...state,
        likedJobs: state.likedJobs.filter(job => job.id !== action.payload.id),
      };

    case LOGOUT: 
      return initialState;

    default:
      return state;
  }
};

export default profileSetupReducer;
